<template>
  <div class="pb60">
    <draggable v-model="pageInfo" handle=".list_item">
      <div v-for="(item, index) in pageInfo" :key="index" class="mb20">
        <div class="m10 p10 br10 box-s">
          <div class="acsb">
            <div class="ac">
              <div class="ac ml20">
                <div class="w100 subtitle">板块标题：</div>
                <el-input v-model="item.name" class="w300"></el-input>
              </div>
              <div class="ac ml20">
                <div class="w100 subtitle">板块key：</div>
                <el-input v-model="item.key" class="w300"></el-input>
              </div>
            </div>
            <div>
              <el-button icon="el-icon-rank" circle class="list_item"></el-button>

              <el-button type="danger" icon="el-icon-delete" circle @click="deleteItemFunc(pageInfo, index)"></el-button>
            </div>
          </div>

          <div class="p10">
            <!-- {{  }} -->
            <draggable v-model="item.content" handle=".dataItem">
              <div v-for="(b, x) in item.content" :key="x" class="rowData">
                <div class="mb20 box-s br10 p10 acsb fs14">
                  <div class="ac wrap">
                    <div class="ac mr20 mb10">
                      <div class="pr10">标题：</div>
                      <el-input v-model="b.name" class="w200"></el-input>
                    </div>
                    <div class="ac mr20 mb10">
                      <div class="pr10">必填</div>
                      <el-switch v-model="b.required"> </el-switch>
                    </div>
                    <div class="ac mr20 mb10">
                      <div class="pr10">类型:</div>
                      <el-select v-model="b.type" placeholder="请选择" class="w140">
                        <el-option :label="select" :value="select" v-for="(select, sindex) in typeOptions" :key="sindex"></el-option>
                      </el-select>
                    </div>

                    <div class="ac mr20 mb10">
                      <div class="pr10">数据类型:</div>
                      <el-select v-model="b.dataType" placeholder="请选择" class="w140" filterable allow-create default-first-option>
                        <el-option :label="select" :value="select" v-for="(select, sindex) in ['种植', '养殖', '人口', '其他']" :key="sindex"></el-option>
                      </el-select>
                    </div>

                    <div class="ac mr20 mb10">
                      <div class="pr10">数据库key：</div>
                      <el-input v-model="b.key" class="w200"></el-input>
                    </div>

                    <div class="ac mr20 mb10">
                      <div class="pr10">默认值</div>
                      <el-input v-model="b.value" class="w200"></el-input>
                    </div>
                    <div class="ac ml10 mb10">
                      可否修改：
                      <el-switch v-model="b.canUpdate"> </el-switch>
                    </div>

                    <div class="ac ml10 mb10">
                      是否条显：
                      <el-switch v-model="b.ifShow"> </el-switch>
                    </div>

                    <div class="ac p10 br10 mt10 box-s ml10 mb10" v-if="b.ifShow">
                      判断条件：
                      <el-input v-model="b.ifTitle" placeholder="请输入" class="w200 mr10"></el-input>
                      <el-select v-model="b.ifType" placeholder="请选择" class="mr10">
                        <el-option v-for="ifItem in ['等于', '不等于', '有', '没有']" :key="ifItem" :label="ifItem" :value="ifItem"> </el-option>
                      </el-select>
                      <el-input v-model="b.ifData" placeholder="请输入" class="w200"></el-input>
                    </div>

                    <div class="ac mr20 mb10 ml10" v-if="b.type == '多张图片'">
                      <div class="pr10">图片数:</div>
                      <el-input v-model="b.img_num" type="number" class="w100"></el-input>
                    </div>

                    <div class="ac p10 br10 mt10 box-s ml10 mb10" v-if="['单选', '多选'].includes(b.type)">
                      选项：
                      <!-- {{ b.options }} -->
                      <div v-for="(option, oindex) in b.options" :key="oindex">
                        <div class="p4 box-s br10 mr10 ac mb10">
                          <el-input v-model="option.name" placeholder="请输入" @input="$forceUpdate()"></el-input>
                          <i class="el-icon-delete ml10" style="color: red" @click="deleteItemFunc(b.options, oindex)"></i>
                        </div>
                      </div>

                      <el-button type="primary" @click="addOptions(b, {name: ''})" size="mini">新增选项</el-button>
                    </div>

                    <div class="ac mr20 mb10" v-if="['下拉选择多级', '下拉选择1级'].includes(b.type)">
                      <div class="pr10 no-wrap">后端api:</div>
                      <el-input v-model="b.option_api" class="w300"></el-input>
                    </div>
                  </div>

                  <div class="ac">
                    <el-button icon="el-icon-rank" size="mini" circle class="dataItem"></el-button>
                    <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="deleteItemFunc(item.content, x)"></el-button>
                  </div>
                </div>
              </div>
            </draggable>

            <div class="tac mt20">
              <el-button type="primary" @click="addItemFunc(item.content, addTitle)" size="mini">添加内容</el-button>
            </div>
          </div>
        </div>
      </div>
    </draggable>
    <div class="tac">
      <div>
        <el-button type="primary" @click="addItemFunc(pageInfo, addItem)">添加板块</el-button>

        <el-button type="success" @click="save(pageInfo)">保存配置</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {http_get, http_post} from '@/api/api'
import draggable from 'vuedraggable'

export default {
  components: {draggable},
  props: {
    Identity: {
      type: String,
      default: 'user'
    }
  },
  data() {
    return {
      pageInfo: [],
      typeOptions: ['文字', '数字', '图片', '长文本', '视频', '多张图片', '单选', '多选', '村选择'],

      addItem: {
        name: '',
        content: []
      },
      addTitle: {
        name: '',
        type: '文字',
        show: 0,
        value: '',
        options: []
      }
    }
  },

  created() {
    http_post('/api/admin/form/info', {Identity: this.Identity}, 1).then(res => {
      this.pageInfo = res.data
    })
  },
  computed: {},
  methods: {
    addOptions(row, item) {
      if (row.options) {
        row.options.push(JSON.parse(JSON.stringify(item)))
      } else {
        row.options = [JSON.parse(JSON.stringify(item))]
      }
      console.log(row, item)
      this.$forceUpdate()
    },

    addItemFunc(rows, item) {
      rows.push(JSON.parse(JSON.stringify(item)))
    },
    save(data) {
      http_post('/api/admin/form/add', {content: data, Identity: this.Identity}).then(res => {
        this.pageInfo = res.data
      })
    },
    deleteItemFunc(rows, index) {
      this.$confirm('确认删除？', '提示', {type: 'warning'})
        .then(() => rows.splice(index, 1))
        .catch(() => this.$message.info('已取消删除'))
    }
  }
}
</script>

<style lang="scss" scoped>
.rowData {
  transition: background-color 0.3s ease; /* 过渡效果，0.3秒 */
}

.rowData:hover {
  background-color: #f5f5f5;
}
</style>
